import React from "react";
import NotFound from "../Screens/Common/NotFound";
import Home from "../Screens/User/Home";
import About from "../Screens/User/About";
import Contact from "../Screens/User/Contact";
import Services from "../Screens/User/Services";
import Blogs from "../Screens/User/Blogs";
import Projects from "../Screens/User/Projects";
import Sectors from "../Screens/User/Sectors";
import Careers from "../Screens/User/Careers";
import Profile from "../Screens/User/Profile";

const userRoutes = [
  { path: "/", component: <Home /> },
  { path: "/about", component: <About /> },
  { path: "/contact", component: <Contact /> },
  { path: "/services", component: <Services /> },
  { path: "/projects", component: <Projects /> },
  { path: "/blogs", component: <Blogs /> },
  { path: "/sectors", component: <Sectors /> },
  { path: "/profile", component: <Profile /> },
  { path: "/careers", component: <Careers /> },
  { path: "*", component: <NotFound /> },
];

export { userRoutes };
